<template>
    
  <section id="banner">
    <div class="overlay"></div>
  </section>
    
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'Intro',
    components: { 

    },
    props: {
    },
    data() {
      return {
      }
    },
    methods: {
    },
    beforeMount() {
    },
    beforeDestroy() {
    },
    computed: {},
  mounted() {
  },
  beforeDestroy() { 
    
  },
  watch: {
  },

})
</script>

